import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  eventTitle: {
    paddingInline: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  actionsContainer: {
    borderTop: 'solid 1px',
    borderTopColor: theme.palette.grey[400],
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(),
    '& button': {
      marginRight: theme.spacing()
    }
  },
  titleAndSelect: {
    display: 'flex',
    alignItems: 'baseline'
  },
  field: {
    maxWidth: 220,
    marginLeft: 25,
    '& .MuiSelect-select.MuiSelect-select': {
      paddingLeft: 10,
      paddingRight: 30
    }
  },
  containerButtons: {
    display: 'flex',
    gap: 8,
    alignItems: 'center'
  }
}))

export default useStyles
